import Context from '../../common/context/context';


class ModalContext extends Context {

	constructor({name, root, popOnKey = 'esc', fixedClass = 'fixed', activeClass = 'active', activeElementAttribute =  'activeElement'}) {
		super({name: name, root: root, popOnKey: popOnKey});
		this.activeClass = activeClass;
		this.fixedClass = fixedClass;
		this.activeElementAttribute = activeElementAttribute;
		this.isIe = !!document.querySelector('html.ie');
	}


	getLevel() {
		return 1;
	}


	getActiveElement() {
		const element = this.getElement();
		const activeElement = element.querySelector(this.dataSelector(this.activeElementAttribute));
		return (activeElement ? activeElement : element);
	}


	beforeSwitchIn(otherContext) {
		return otherContext;
	}


	switchIn(otherContext) {
		const element = this.getElement();
		this.clickOutListener = this.events.on(element, 'click', this.onElementClick.bind(this));
		this.linkListener = this.events.on(this.root, 'a', 'click', this.onLinkClick.bind(this));
		this.threeStateTransition(element).add(this.activeClass);
		window.scrollTo(0, 0);
		return otherContext;
	}


	switchOut(otherContext) {
		const element = this.getElement();
		this.classList(element).add(this.fixedClass);
		if (this.clickOutListener) {
			this.clickOutListener.destroy();
		}
		if (this.linkListener) {
			this.linkListener.destroy();
		}
		this.threeStateTransition(element).remove(this.activeClass).then(() => {
			this.classList(element).remove(this.fixedClass);
			return otherContext;
		});
		return otherContext;
	}


	onLinkClick(event, target) {
		if (this.contexts.getCurrentContext() === this) {
			const href = target.getAttribute('href');
			if (href.charAt(0) !== '#' || !this.getElement().querySelector(href)) {
				const promise = this.contexts.pop();
				if (!this.isIe) {
					event.preventDefault();
					promise.then(() => {
						target.click();
					});
				}
			}
		}
	}


	/**
	 * Closing the modal when clicking outside the element (technically still inside it, on its pseudo element ::before)
	 * @param {MouseEvent} event
	 * @param {Element} target
	 */
	onElementClick(event, target) {
		const element = this.getElement();
		if (target === element) {
			const rect = this.getActiveElement().getBoundingClientRect();
			const x = event.clientX;
			const y = event.clientY;
			if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
				this.contexts.pop();
			}
		}
	}

}


export default ModalContext;
